// extracted by mini-css-extract-plugin
export default {"e_text_button":"text-button_e_text_button__w3BBa","e_back_icon":"text-button_e_back_icon__yzdzm"};